module.exports = __webpack_public_path__ + "static/img/brand-2.272e166.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand-2.png
// module id = rCdb
// module chunks = 0